<template>
	<nk-wrapper v-if="context.organisationseinheit" spacing="md">
		<nk-title tag="h1" size="4xl">
			{{ context.organisationseinheit.name }}
		</nk-title>

		<nk-wrapper
			v-if="
				context.organisationseinheit.textbloecke.find(
					textblock => textblock.typ === 'preamble',
				).text
			"
		>
			<div
				class="nk-cms-content"
				v-html="
					context.organisationseinheit.textbloecke.find(
						textblock => textblock.typ === 'preamble',
					).text
				"
			/>
		</nk-wrapper>

		<nk-wrapper spacing="lg">
			<nk-row vertical-gutter="3">
				<nk-col
					v-if="context.organisationseinheit.anschriften.length"
					cols="full"
					lg="auto"
				>
					<nk-title tag="h2" size="xl">Anschriften</nk-title>
					<nk-list variant="overview">
						<nk-list-item
							v-for="(anschrift, indexAnschriften) in context
								.organisationseinheit.anschriften"
							:key="indexAnschriften"
						>
							<nk-title tag="h2" size="md" no-margin>
								{{ anschrift.titel }}
							</nk-title>
							<nk-address
								v-if="anschrift.type !== 'POSTFACH'"
								:strasse="`${anschrift.strasse} ${anschrift.hausnummer}`"
								:plz="anschrift.postleitzahl"
								:ort="anschrift.ort"
							/>
							<nk-address
								v-else
								:postfach="anschrift.postfach"
								:plz="anschrift.postleitzahl"
								:ort="anschrift.ort"
							/>
						</nk-list-item>
					</nk-list>
				</nk-col>
				<nk-col
					v-if="context.organisationseinheit.oeffnungszeiten.text.length > 0"
					cols="full"
					lg="auto"
				>
					<nk-title tag="h2" size="xl">Öffnungszeiten</nk-title>
					<div
						class="nk-cms-content"
						v-html="context.organisationseinheit.oeffnungszeiten.text"
					/>
				</nk-col>
			</nk-row>
		</nk-wrapper>

		<nk-wrapper
			v-if="
				checkForKeyWithValues(
					context.organisationseinheit.kommunikation,
					'kanal',
					['TELEFON', 'MOBILTELEFON', 'EMAIL', 'FAX'],
				) ||
				(context.organisationseinheit.internetadressen &&
					context.organisationseinheit.internetadressen.length)
			"
			spacing="lg"
		>
			<nk-title :id="`title-${titleId}`" tag="h2" size="xl">
				Kontaktmöglichkeiten
			</nk-title>
			<nk-address
				:telefon="
					context.organisationseinheit.kommunikation &&
					context.organisationseinheit.kommunikation.find(
						kontaktArt => kontaktArt.kanal === 'TELEFON',
					)
						? context.organisationseinheit.kommunikation.find(
								kontaktArt => kontaktArt.kanal === 'TELEFON',
							).kennung
						: null
				"
				:mobil="
					context.organisationseinheit.kommunikation &&
					context.organisationseinheit.kommunikation.find(
						kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
					)
						? context.organisationseinheit.kommunikation.find(
								kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
							).kennung
						: null
				"
				:email="
					context.organisationseinheit.kommunikation &&
					context.organisationseinheit.kommunikation.find(
						kontaktArt => kontaktArt.kanal === 'EMAIL',
					)
						? context.organisationseinheit.kommunikation.find(
								kontaktArt => kontaktArt.kanal === 'EMAIL',
							).kennung
						: null
				"
				:telefax="
					context.organisationseinheit.kommunikation &&
					context.organisationseinheit.kommunikation.find(
						kontaktArt => kontaktArt.kanal === 'FAX',
					)
						? context.organisationseinheit.kommunikation.find(
								kontaktArt => kontaktArt.kanal === 'FAX',
							).kennung
						: null
				"
			/>
			<nk-nav :aria-labelledby="`title-${titleId}`" prepend-icon="link">
				<nk-nav-item
					v-for="(internetadresse, internetadresseIndex) in context
						.organisationseinheit.internetadressen"
					:key="internetadresseIndex"
					:link="internetadresse.url"
					:title="internetadresse.titel || internetadresse.url"
					:text="internetadresse.beschreibung"
					:aria-label="internetadresse.tooltip"
				/>
			</nk-nav>
		</nk-wrapper>

		<nk-accordion
			v-if="
				context.organisationseinheit.kontaktpersonen &&
				context.organisationseinheit.kontaktpersonen.length
			"
			title="Mitarbeiter"
			group="details"
			title-size="xl"
			:open="true"
		>
			<nk-row vertical-gutter="2" gutter="2">
				<nk-col
					v-for="(mitarbeiter, mitarbeiterIndex) in context.organisationseinheit
						.kontaktpersonen"
					:key="`mitarbeiter-${mitarbeiterIndex}`"
					cols="full"
					sm="6/12"
					xl="4/12"
				>
					<nk-card variant="boxed" :grouped="false">
						<template #header>
							<nk-link
								block
								:link="`${
									context.taggingpfadMitarbeiter.slice(-1) !== '/'
										? context.taggingpfadMitarbeiter + '/'
										: context.taggingpfadMitarbeiter
								}${
									$slugify(mitarbeiter.vorname + '-' + mitarbeiter.nachname) +
									'-id_' +
									mitarbeiter.id
								}`"
							>
								<nk-title tag="h3" size="md" no-margin>
									{{ mitarbeiter.vorname }}
									{{ mitarbeiter.nachname }}
								</nk-title>
							</nk-link>
							<div v-html="mitarbeiter.funktion" />
						</template>
						<template
							v-if="mitarbeiter.kommunikationsmoeglichkeiten?.length"
							#body
						>
							<nk-address
								variant="vertical"
								:telefonnummern="
									mitarbeiter.kommunikationsmoeglichkeiten
										.filter(kontaktArt => kontaktArt.kanal === 'TELEFON')
										.map(telefon => {
											return {
												telefon: telefon.kennung,
												zusatz: telefon.kennungszusatz,
											};
										})
								"
								:email="
									mitarbeiter.kommunikationsmoeglichkeiten &&
									mitarbeiter.kommunikationsmoeglichkeiten.find(
										kontaktArt => kontaktArt.kanal === 'EMAIL',
									)
										? mitarbeiter.kommunikationsmoeglichkeiten.find(
												kontaktArt => kontaktArt.kanal === 'EMAIL',
											).kennung
										: null
								"
								:mobil="
									mitarbeiter.kommunikationsmoeglichkeiten &&
									mitarbeiter.kommunikationsmoeglichkeiten.find(
										kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
									)
										? mitarbeiter.kommunikationsmoeglichkeiten.find(
												kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
											).kennung
										: null
								"
							/>
						</template>
					</nk-card>
				</nk-col>
			</nk-row>
		</nk-accordion>

		<nk-accordion
			v-if="context.organisationseinheit.formulare.length"
			v-slot="{titleId: accordionTitleId}"
			title="Formulare"
			group="details"
			title-size="xl"
		>
			<nk-nav :aria-labelledby="accordionTitleId">
				<nk-nav-item
					v-for="(formular, formularIndex) in context.organisationseinheit
						.formulare"
					:key="formularIndex"
					:link="formular.url"
					:aria-label="getLinkAriaLabel(formular.name, formular.url)"
				>
					{{ formular.name }}
					<template v-if="getFileTypeFromFileName(formular.url) === 'pdf'">
						(PDF)
					</template>
					<template v-if="['FORMULAR', 'ONLINEDIENST'].includes(formular.typ)">
						<br />
						<span
							v-if="formular.typ === 'FORMULAR'"
							class="inline-block text-sm"
						>
							<nk-icon icon="file" size="sm" />
							Formular
						</span>
						<span
							v-if="formular.typ === 'ONLINEDIENST'"
							class="inline-block text-sm"
						>
							<nk-icon icon="globe" size="sm" />
							Onlinedienst
						</span>
					</template>
				</nk-nav-item>
			</nk-nav>
		</nk-accordion>

		<nk-accordion
			v-if="context.organisationseinheit.leistungen.length"
			title="Leistungen dieses Fachbereichs"
			group="details"
			title-size="xl"
		>
			<nk-service-bw-leistungen
				:taggingpfad="context.taggingpfadLeistungen"
				:leistungen="context.organisationseinheit.leistungen"
			/>
		</nk-accordion>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import Helpers from '../../mixins/helpers';
import {useCMS, updateBreadcrumb, useSEO} from '#nk/composables/cms';
import {useId} from '#imports';
import {getFileTypeFromFileName, getLinkAriaLabel} from '#nk/helpers';

/**
 * @prop {object} context.organisationseinheit
 * @prop {string} context.taggingpfadLeistungen
 * @prop {string} context.taggingpfadMitarbeiter
 */
export default {
	name: 'NkTemplateServiceBwOrganisationseinheitsDetails',

	mixins: [TemplatesDefault, Helpers],

	setup(ctx) {
		const page = useCMS();

		const organisationseinheit = {
			name: ctx?.context?.organisationseinheit?.name || '',
		};

		if (organisationseinheit.name) {
			updateBreadcrumb({title: organisationseinheit.name});
		}

		useSEO({
			title: page.value.title
				? `${page.value.title} ${organisationseinheit.name}`
				: organisationseinheit.name,
		});

		const titleId = useId();
		return {titleId, getFileTypeFromFileName, getLinkAriaLabel};
	},
};
</script>
